// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/index.js!./mobile-order-cards.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js")("cf50edc2", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile-order-cards.css
// module id = 2091
// module chunks = 0